import axios from "axios";
// initial state

const getDefaultState = () => {
  return {
    mobileNetworks: [],
    mobileNetwork: {},
    totalItems: null,
    totalPage: null,
  }
}

const state = getDefaultState();

// getters
const getters = {
  getMobileNetworkList(state) {
    return state.mobileNetworks;
  },

  getMobileNetwork() {
    return state.mobileNetwork;
  },

  getTotalPages() {
    return state.totalPage;
  },

  getTotal() {
    return state.totalItems;
  },
};

// actions
const actions = {
  GetMobileNetworks({ commit }, list) {
    return axios({
        url: "/mobile_network/list?order_dir=desc" ,
        params: {
          // page: list.page || 0,
          per_page: list.per_page || 10,
          iso3: list.iso3 || '',
          // country_code: list.country_code || ''
        },
        method: "GET"
      }).then(res => {
        const { items: mobileNetworks, total, per_page } = res.data.payload;
        commit('SET_MOBILE_NETWORKS',  { mobileNetworks, total, per_page });
        return res.data.payload;
      });
  },
  GetMobileNetworksNoCommit({ commit }, list) {
    return axios({
      url: "/mobile_network/list" ,
      params: {
        // page: list.page || 0,
        // per_page: list.per_page || 10,
        iso3: list.id || '',
        // country_code: list.country_code || ''
      },
      method: "GET"
    }).then(res => {

      return res.data.payload;
    });
  },
  GetMobileNetwork({ commit }, id) {
    return new Promise(resolve => {
      axios({
        url: "/mobile_network/" + id ,
        method: "GET"
      }).then(res => {
        commit('SET_MOBILE_NETWORK', res.data.payload)
        resolve(res.data.payload);
      });
    });
  },
  cleanMobileNetworkList({commit}) {
    commit('CLEAN_MOBILE_NETWORK_LIST');
  },
  resetMobileNetworkState ({ commit }) {
    commit('RESET_STATE');
  }
};
// mutations
const mutations = {
  SET_MOBILE_NETWORKS(state, { mobileNetworks, total, per_page }) {
    state.mobileNetworks = mobileNetworks;
    state.totalPage = total / per_page;
    state.totalItems = total;
    state.mobileNetwork = mobileNetworks[0] || {}; // added
  },

  SET_MOBILE_NETWORK(state, mobileNetwork) {
    state.mobileNetwork = mobileNetwork;
  },

  CLEAN_MOBILE_NETWORK_LIST(state) {
    state.mobileNetworks = [];
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
